module.exports = __webpack_public_path__ + "9f3d1126ed6604517e21c58af38b4e3d.svg";